<!--================================
=            DRAWERMINI            =
=================================-->

<template>
    <div>
        <div class="text-center">
            <v-avatar class="text-center align-center rounded-lg ma-1  transparent" size="80"> <img
                     src="../../assets/images/logo-mini.png"></v-avatar>
        </div>
        <div class="text-center pa-2">
            <v-menu v-for="item in items" :key="item.title" v-if="item.action" bottom :offset-x="offset"
                    class="ma-1 text-center on-hover transparent">
                <template v-slot:activator="{ on, attrs }">
                    <v-bottom-navigation max-width="80" outlined
                                         class="elevation-2 rounded-lg ml-1 mt-2 transparent white--text" :value="value"
                                         grow>
                        <v-btn class="elevation-0 drawer-mini-btn transparent white--text mx-auto" width="70"
                               height="60" text outlined large v-bind="attrs" v-on="on">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span>{{item.title}}</span>
                                    <v-icon>{{item.action}}</v-icon>
                                </template>
                                <span class="text-caption white--text">{{item.title}}</span>
                            </v-tooltip>

                        </v-btn>
                    </v-bottom-navigation>
                </template>
                <transition name="slideInLeft">
                    <v-list class="text-left rounded-lg card-light" dense>
                        <v-subheader class="ml-5 white--text text-decoration-underline list-icon">{{item.title}}
                        </v-subheader>
                        <v-list-item v-for="subItem in item.items" :key="subItem.title"
                                     :to="{ path: '/' + subItem.path }">
                            <v-icon> arrow_right</v-icon>
                            <v-list-item-content>
                                <v-list-item-title width="100" class="white--text" dark
                                                   v-bind:class="{ active: isActive }" v-text="subItem.title">
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </transition>
            </v-menu>
        </div>

    </div>
</template>

<script>
    import menu from "../../util/menu.js";
    export default {
        data: () => ({
            drawer: true,
            selectedItem: '',
            isActive: true,
            miniVariantWidth: 90,
            items: menu,
            mini: true,
            offset: true,
            value: 1
        }),
        methods: {
            godashboard1() {
                return this.$router.push("/dashboard/dashboard1");
            },

        }



    };
</script>

<style scoped>
    .ps {
        height: 700px !important;
    }

    .card-light {
        border-radius: 1em;
        border: 1px solid rgba(255, 255, 255, 0.5);
        text-shadow: 0 0 1em rgba(0, 0, 0, 0.5);
        background: rgba(255, 255, 255, 0.2);
        -webkit-backdrop-filter: blur(20px);
        backdrop-filter: blur(20px);
        transform: perspective(500px);
        transform-style: preserve-3d;
    }

    .card-dark {
        border-radius: 1em;
        border: 1px solid rgba(0, 0, 0, 0.5);
        text-shadow: 0 0 1em rgba(245, 245, 245, 0.5);
        background: rgba(0, 0, 0, 0.2);
        -webkit-backdrop-filter: blur(20px);
        backdrop-filter: blur(20px);
        transform: perspective(500px);
        transform-style: preserve-3d;
    }
</style>


<!--====  End of DRAWERMINI  ====-->